/* eslint-disable no-undef */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getLivisLanguage } from "../helpers/storage";

import baseEnTranslations from "./locales/en/translations.json";
import esTranslations from "./locales/es/translations.json";
import deTranslations from "./locales/de/translations.json";
import koTranslations from "./locales/ko/translations.json";
import hiTranslations from "./locales/hi/translations.json";
import frTranslations from "./locales/fr/translations.json";

import automotiveTerms from "./locales/industry/automotive.json";
import aerospaceTerms from "./locales/industry/aerospace.json";
import electronicsTerms from "./locales/industry/electronics.json";
import semiTerms from "./locales/industry/semiconductor.json";

const hostname = window.location.hostname;
const isLocalhost =
  hostname === "localhost" ||
  /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/.test(hostname) ||
  hostname === "livis.ai" ||
  hostname === "www.livis.ai";

// 1. Set up the default "en" bucket (Base English)
let defaultEnTranslations = { ...baseEnTranslations };

// 2. If NOT on localhost/base, safely merge the specific industry terms into the default English bucket
if (!isLocalhost) {
  if (hostname.includes("automotive"))
    defaultEnTranslations = { ...defaultEnTranslations, ...automotiveTerms };
  else if (hostname.includes("aerospace"))
    defaultEnTranslations = { ...defaultEnTranslations, ...aerospaceTerms };
  else if (hostname.includes("electronics"))
    defaultEnTranslations = { ...defaultEnTranslations, ...electronicsTerms };
  else if (hostname.includes("semi"))
    defaultEnTranslations = { ...defaultEnTranslations, ...semiTerms };
}

// 3. Define standard resources mapping
const resources = {
  en: { translations: defaultEnTranslations },
  es: { translations: esTranslations },
  de: { translations: deTranslations },
  ko: { translations: koTranslations },
  hi: { translations: hiTranslations },
  fr: { translations: frTranslations },
};

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: getLivisLanguage() || "en",
  supportedLngs: ["en", "es", "de", "ko", "hi", "fr"],
  resources: resources,
  ns: ["translations"],
  defaultNS: "translations",
  load: "currentOnly",
  // React already escapes rendered text, so i18next's own HTML-entity
  // escaping of interpolated values (e.g. "/" -> "&#x2F;") is redundant and
  // wrong here — it renders as a literal encoded string instead of the
  // real character, since React text nodes don't decode HTML entities.
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
